import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

export const deltasToggleLabelSx: SxProps<Theme> = {
  mr: s('none'),
  ml: s('none'),
  columnGap: s('xs'),
  alignItems: 'center',
  '& .MuiFormControlLabel-label': {
    mr: s('none'),
    display: 'flex',
    alignItems: 'center',
  },
};

export const deltasToggleCheckboxSx: SxProps<Theme> = {
  px: s('xs'),
  py: s('none'),
};
